<template>
  <div class="page news-detail">
    <div class="page-body" v-loading="loading">
      <div class="panel">
        <div class="panel-body">
          <div class="html-view">
            <div class="head">
              <div class="title">{{ infoData.title }}</div>
              <div class="sec_list">
                <div class="item">
                  <span>作者：</span>
                  <span>{{ infoData.writer }}</span>
                </div>
                <div class="item">
                  <span>阅读量：</span>
                  <span>{{ infoData.view_count }}</span>
                </div>
              </div>
              <el-button type="primary" plain :loading="isCollectLoad" @click="handleCollect()" class="btnCollect">
                <span>{{ formCollect ? '取消采集' : '采集到云库' }}</span>
                <img src="@/assets/home/gather.png" alt style="height: 14px; vertical-align: middle" />
              </el-button>
            </div>
            <div class="body">
              <div class="htmlStyle" v-html="infoData.content"></div>
              <div class="poster-cont">
                <el-image class="image" :src="infoData.cover" @error="handleError" />
              </div>
            </div>
          </div>
          <!-- <div class="sequence-page">
            <el-button type="text">上一篇</el-button>
            <el-button type="text">下一篇</el-button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNewsInfo } from "@/api/activity"
import { setCollect } from "@/api/common"
export default {
  name: "NewsDetail",
  components: {},
  data() {
    return {
      queryObj: {}, // 路由传参
      infoData: {},
      loading: false,
      defaultImg: require("@/assets/default/image02.jpg"),
      isCollectLoad: false, // 加入防抖
      formCollect: false,
    }
  },
  filters: {},
  watch: {},
  created() {
    this.queryObj = this.$route.query || {}
    this.getInfo()
  },
  mounted() { },
  methods: {
    // 获取详情信息
    getInfo() {
      this.loading = true
      const params = { id: this.queryObj?.id ?? "" }
      getNewsInfo(params).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.infoData = res.data
          this.formCollect = res.data.is_collect_activity ? true : false
        }
      }).catch(() => { })
    },
    // 当图片加载失败时，将图片地址设置为默认图片
    handleError(e) {
      e.target.src = this.defaultImg
    },
    // 采集到云库
    handleCollect() {
      this.isCollectLoad = true
      let params = {
        id: this.queryObj?.id ?? "",
        type: 1
      }
      setCollect(params).then((res) => {
        this.isCollectLoad = false
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: this.formCollect ? '取消采集成功!' : '采集成功!'
          })
          this.getInfo()
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  padding: 30px 60px;
  background-color: #fff;
  margin-top: 20px;

  .page-body {
    position: relative;

    .panel {
      background-color: #fff;
      border-radius: 10px;

      .panel-body {
        min-height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .panel-head {
          padding: 10px;
        }

        .panel-title {
          color: #000;
          font-size: 24px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }

    .html-view {
      color: #333;
      font-size: 14px;
      font-weight: 400;
      line-height: 30px;
      overflow: hidden;
      /* 溢出隐藏 */
      position: relative;

      /* 子绝父相，这里是为了给伪元素设置定位*/
      .head {
        text-align: center;
        margin-bottom: 30px;
        position: relative;

        .btnCollect {
          position: absolute;
          right: 0px;
          top: 0px;
        }
      }

      .title {
        color: #000;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .sec_list {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;

        .item {
          display: inline-block;
          margin: 0 10px;
        }
      }

      .body {
        ::v-deep .htmlStyle {
          p {
            text-indent: 2em;
            padding: 0;
            margin-bottom: 5px;
          }

          img {
            display: block;
            width: 100%;
            max-width: 100%;
            margin: 10px auto;
          }
        }

        .poster-cont {
          margin-top: 26px;
        }
      }
    }

    .sequence-page {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    padding: 15px 10px;
    margin-top: 10px;

    .page-body {
      .panel {
        .panel-body {
          min-height: auto;

          .panel-title {
            font-size: 18px;
            line-height: 1.4;
          }
        }
      }

      .html-view {
        .head {
          margin-bottom: 15px;

          .btnCollect {
            position: relative;
            right: auto;
            top: auto;
            margin-top: 10px;
            padding: 8px 12px;
            font-size: 12px;
            height: 30px;

            img {
              height: 12px;
            }
          }

          .title {
            font-size: 18px;
          }

          .sec_list {
            .item {
              margin: 0 5px;
            }
          }
        }
      }

      .sequence-page {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    padding: 20px 30px;
  }
}

@media screen and (min-width: 1200px) {}
</style>